<form *ngIf="workerBillableItemFormGroup" [formGroup]="workerBillableItemFormGroup">
    <div class="grid">
        <div class="col-9 input-field">
            <label for="workerBillableItemTypeId">Tipo *</label>
            <p-dropdown [options]="workerBillableItemTypes" formControlName="workerBillableItemTypeId" [required]="true" optionValue="id"
                [filter]="true" filterBy="description" optionLabel="description" placeholder="Seleccione tipo" (onChange)="onWorkerBillableItemTypeChange()" appendTo="body"
                d-form-field-error />                                   
        </div>
        <div class="col-3 input-field">
            <label for="active" class="mr-1">Activo</label>
            <div class="flex h-full">
                <p-inputSwitch id="active" formControlName="active"></p-inputSwitch>
            </div>
        </div>
        <div class="col-12 input-field" *ngIf="selectedType?.code=='ZONE_ATTENDANCE'">
            <label for="zoneId">Zona *</label>
            <p-dropdown [options]="zones" formControlName="zoneId" [required]="true" optionValue="id"
                [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione zona" appendTo="body"
                d-form-field-error />                                   
        </div>
        <div class="col-12 input-field" *ngIf="selectedType?.code=='DISTANCE'">
            <label for="decimalValue1">Kilometros mínimos *</label>
            <input formControlName="decimalValue1" pInputText type="number" d-form-field-error />                                
        </div>
        <div class="col-12 input-field">
            <label for="description">Descripción *</label>
            <textarea pInputTextarea formControlName="description" rows="3" style="field-sizing: content;"
                d-form-field-error></textarea>
        </div>
        <div class="col-3 input-field ">
            <label for="startDate">Desde *</label>
            <p-calendar [firstDayOfWeek]="1" inputId="startDate" appendTo="body" dateFormat="dd/mm/yy" formControlName="startDate"
                panelStyleClass="cal-lateral" (onShow)="posicionarCalendarioLateral('startDate')"
                (onClose)="cerrarCalendarioLateral()" d-form-field-error />
        </div>
        <div class="col-3 input-field ">
            <label for="endDate">Hasta *</label>
            <p-calendar [firstDayOfWeek]="1" inputId="endDate" appendTo="body" dateFormat="dd/mm/yy" formControlName="endDate"
                panelStyleClass="cal-lateral" (onShow)="posicionarCalendarioLateral('endDate')"
                (onClose)="cerrarCalendarioLateral()" d-form-field-error />

        </div>
        <div class="col-4 input-field">
            <label for="isPayToWorker">Cobro/Cargo</label>
            <p-dropdown [options]="IsPayToWorkerOptions" formControlName="isPayToWorker" [required]="true" optionValue="value"
                [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione quén paga" appendTo="body"
                d-form-field-error />                                   
        </div> 
        <div class="col-2 input-field">
            <label for="isPeriodic" class="mr-1">Mensual</label>
            <div class="flex h-full">
                <p-inputSwitch id="isPeriodic" formControlName="isPeriodic"></p-inputSwitch>
            </div>
        </div>
        <div class="col-3 input-field">
            <label for="quantity">Cantidad</label>
            <input formControlName="quantity" pInputText type="number" d-form-field-error
                (input)="calculatePrices()">
        </div>
        <div class="col-3 input-field">
            <label for="price">Precio</label>
            <input formControlName="price" pInputText type="number" d-form-field-error
                (input)="calculatePrices()">
        </div>
        <div class="col-3 input-field">
            <label for="code">Impuestos(%)</label>
            <p-dropdown formControlName="taxId" [options]="taxes" optionLabel="name" optionValue="id"
                appendTo="body" filterBy="name" placeholder="Seleccione opción" (onChange)="calculatePrices()"
                d-form-field-error></p-dropdown>
            <label class="mt-2">
                {{ workerBillableItemFormGroup.get('taxAmount')?.value | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>
        <div class="col-3 input-field flex">
            <div class="col-6 p-0">
                <label class="mb-3" for="subtotal">Neto</label>
                <span class="mt-2">
                    {{ subtotal | currency:'EUR':'symbol':'1.2-2' }}
                </span>
            </div>   
            <div class="col-6 p-0">
                <label class="mb-3" for="total">Total</label>
                <span class="mt-2">
                    {{ total | currency:'EUR':'symbol':'1.2-2' }}
                </span>
            </div>    
        </div>    
        <div class="col-12 input-field">
            <label for="notes">Notas</label>
            <textarea pInputTextarea formControlName="notes" style="field-sizing: content;" rows="5"
                d-form-field-error></textarea>
        </div>   

    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && workerBillableItem.id && workerBillableItem.workerVehicleId == null" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite && workerBillableItem.workerVehicleId == null" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>